export default __webpack_public_path__ + "static/media/system-tag-round.e90eadb7.svg";